import { usePageTracking } from "react-event-tracker";
import { PageData, TrackingData } from "../../types";
import { useProfile } from "../hooks/auth/useProfile";

const PageTrackingComponent = ({ children, pageData }) => {
  usePageTracking(pageData);
  return children;
};

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  pageData: PageData;
}
export const PageTracking = ({ pageData, children }: Props) => {
  const { isLoggedIn } = useProfile();

  const authenticationStatus = isLoggedIn ? "logged in" : "not logged in";
  const pageDataWithUserAuth: TrackingData["pageData"] = {
    ...pageData,
    user: { authenticationStatus },
  };

  return (
    <PageTrackingComponent pageData={pageDataWithUserAuth}>
      {children}
    </PageTrackingComponent>
  );
};
